export default __webpack_public_path__ + "static/microsoft-d4ba659124a4b7188f3c13b540ee7f8e.svg";